import React from 'react';
import styled from 'styled-components';
import RadioButton from '../common/RadioButton';

const Grid = styled.div`
  gap: 2rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  margin-bottom: 3rem;
`;

const Part = styled.div`
  display: flex;
  flex-direction: row;
  width: 25rem;
  /* 프론트엔드 추가모집 */
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
`;

const Text = styled.div`
  margin-left: 3rem;
  text-align: center;
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 1.5rem;
`;

export const application_list = [
  '인턴개발자 - 프론트엔드',
  '리드개발자 - 프론트엔드',
  '인턴개발자 - 백엔드',
  '리드개발자 - 백엔드',
];

const DeveloperPart = ({ part, onClickPart, readOnly }) => {
  // const isFrontend = (id) => id === 1 || id === 2; //* 프론트 추가모집일시 
  const isFrontend = (id) => true;

  return (
    <Grid>
      <Part disabled={!isFrontend(1)}>
        <RadioButton
          checked={part === 1}
          onClick={() =>
            readOnly || !isFrontend(1) ? undefined : onClickPart(1)
          }
        />
        <Text>인턴개발자 - 프론트엔드</Text>
      </Part>
      <Part disabled={!isFrontend(2)}>
        <RadioButton
          checked={part === 2}
          onClick={() =>
            readOnly || !isFrontend(2) ? undefined : onClickPart(2)
          }
        />
        <Text>리드개발자 - 프론트엔드</Text>
      </Part>
      <Part disabled={!isFrontend(3)}>
        <RadioButton
          checked={part === 3}
          onClick={() =>
            readOnly || !isFrontend(3) ? undefined : onClickPart(3)
          }
        />
        <Text>인턴개발자 - 백엔드</Text>
      </Part>
      <Part disabled={!isFrontend(4)}>
        <RadioButton
          checked={part === 4}
          onClick={() =>
            readOnly || !isFrontend(4) ? undefined : onClickPart(4)
          }
        />
        <Text>리드개발자 - 백엔드</Text>
      </Part>
    </Grid>
  );
};

export default DeveloperPart;
